module.exports = __webpack_public_path__ + "img/wine-glass-alt.9b8841f5.svg";